import React, { useEffect, useState } from "react";
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import FileUpload from "../../../FileUploads/FileUpload";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import { toast } from "react-toastify";
import Moment from "moment";
import SuccessModal from "../../../CustomModal/Success";
import DistanceCalculator from "../../../DistanceCalculator/Calculator";
import DropDownInput from "../../../Input/dropDownInput/dropDownInput";

const CompleteBaActivity = ({
  documentUploadUrlPublic,
  documentUrlDataPublic,
  history,
  match,
  activityTypesDetails = [],
  activityTypes,
  saveActivity,
  saveActivityRes = [],
  activityByIdDetails = [],
  viewActivity,
  getSenior,
  senior = [],
  getPendingActivity,
  pendingActivity = [],
  isCheckoutDetails = [],
  isCheckout,
  markAttendance,
  attendance = [],
}) => {
  var now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  const islatlng = useLatLng();
  const [isLoading, setIsLoading] = useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    lat: 0,
    lng: 0,
  });
  const [isAllow, setIsAllow] = useState(false);
  const [inputList, setInputList] = useState([
    {
      meta_data: {},
      lat: "",
      long: "",
      activity_type_id: "",
      activity_date: "",
      description: "",
    },
  ]);
  const [isActivityCreated, setIsActivityCreated] = useState(false);
  const [openCheckIn, setOpenCheckIn] = useState(true);
  const [checkInText, setCheckInText] = useState("Check In");
  const [distance, setDistance] = useState();
  const [currentDate, setCurrentDate] = useState(
    now.toISOString().slice(0, 16)
  );
  const [isEdit, setIsEdit] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [scope, setScope] = useState([]);
  const [feedback, setFeedback] = useState([]);
  const [primaryLeadStatus, SetPrimaryLeadStatus] = useState([
    {
      lead_status: [],
      follow_up_date: [],
      Dropped: [],
      signed: [],
      cheque: [],
      price: [],
    },
  ]);
  const [addOnLeadStatus, SetAddonLeadStatus] = useState([
    {
      lead_status: [],
      follow_up_date: [],
      Dropped: [],
      signed: [],
      cheque: [],
      price: [],
    },
  ]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await viewActivity(match?.params?.id);
      await activityTypes("is_ba");
      await getSenior();
      // await getPendingActivity()
      setIsLoading(false);
    })();
    if (
      match?.params?.is_edit !== undefined &&
      parseInt(match?.params?.is_edit) === 1
    ) {
      setIsEdit(true);
    }
  }, []);

  const handleScope = (i) => {
    scope[i] = "Other";
    setScope(scope);
  };

  const handlePrimaryLeadStatus = (i, val, key) => {
    primaryLeadStatus[0][key][i] = val;
    SetPrimaryLeadStatus(primaryLeadStatus);
    setTimeout(() => {
      setIsLoading(true);
      setIsLoading(false);
    }, 1000);
  };

  const handleAddOnLeadStatus = (i, val, key) => {
    addOnLeadStatus[0][key][i] = val;
    SetAddonLeadStatus(addOnLeadStatus);
    setTimeout(() => {
      setIsLoading(true);
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if (!isNaN(lati) && !isNaN(langi)) {
      setMapLocation({
        address: "Delhi6",
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
    }
  }, [islatlng]);

  const toRad = (Value) => {
    return (Value * Math.PI) / 180;
  };

  const calcCrow = (lat1, lon1, lat2, lon2) => {
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  };

  useEffect(() => {
    // after check in hide popup
    if (attendance?.data !== undefined && attendance?.status === 200) {
      toast.success("Attendance is marked successfully");
      setOpenCheckIn(false);
      window.location.href = `ba-activity-list/${match?.params?.lead_id}`;
      // if (checkInText === "Check out") {
      //     window.location.href = `ba-activity-list/${match?.params?.lead_id}`
      // }
    }
  }, [attendance]);

  useEffect(() => {
    if (
      pendingActivity?.data !== undefined &&
      pendingActivity?.data !== null &&
      Object.keys(pendingActivity?.data).length > 0
    ) {
      setIsActivityCreated(true);
    }
  }, [pendingActivity]);

  useEffect(() => {
    if (
      isCheckoutDetails?.data !== null &&
      isCheckoutDetails?.data !== undefined &&
      Object.keys(isCheckoutDetails?.data).length > 0
    ) {
      setOpenCheckIn(false);
    }
  }, [isCheckoutDetails]);

  useEffect(() => {
    (async () => {
      if (
        activityByIdDetails?.data !== undefined &&
        activityByIdDetails?.data !== null &&
        Object.keys(activityByIdDetails?.data).length > 0
      ) {
        await getPendingActivity(activityByIdDetails?.data?.account_id);
        await isCheckout("BA", activityByIdDetails?.data?.account_id);
      }
    })();
  }, [activityByIdDetails]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let list = inputList[0];
    list["activity_type_id"] = activityByIdDetails?.data?.activity_type_id;
    if (list["activity_type_id"] === "") {
      toast.error("Please choose activity type");
      return false;
    }

    list["activity_date"] = currentDate;
    if (list["activity_date"] === "") {
      toast.error("Please choose activity date");
      return false;
    }

    list["lat"] = islatlng?.lat;
    list["long"] = islatlng?.lng;
    list["id"] = activityByIdDetails?.data?.id;
    list["primary"] = primaryLeadStatus;
    list["add_on"] = addOnLeadStatus;

    if (list["long"] == null || list["lat"] == null) {
      toast.error("Please enable your location");
      return false;
    }

    // if (!isActivityCreated && list['activity_type_id'] !== '') {
    //     toast.error("No pending activity! Create new one.")
    //     return false
    // }
    // console.log("listlistlistlist " + JSON.stringify(list))
    // return false
    setIsLoading(true);
    await saveActivity(list);
    setIsLoading(false);
  };

  const handleInput = (key, val, metaKey, e, i = 0) => {
    let list = [...inputList];
    if (key === "meta_data") {
      inputList[0][key][metaKey] = val;
    } else {
      inputList[0][key] = val;
    }
    setInputList(list);
  };

  useEffect(() => {
    if (saveActivityRes?.status === 200) {
      setOpenCheckIn(false);
      setCheckInText("Check out");
    } else if (
      saveActivityRes?.status !== undefined &&
      saveActivityRes?.status !== 200
    ) {
      setCountToOpenModal(countToOpenModal + 1);
    }
  }, [saveActivityRes]);

  useEffect(() => {
    if (
      activityByIdDetails?.data !== null &&
      activityByIdDetails?.data !== undefined &&
      Object.keys(activityByIdDetails?.data).length > 0 &&
      isCheckoutDetails?.data !== null &&
      isCheckoutDetails?.data !== undefined &&
      Object.keys(isCheckoutDetails?.data).length > 0
    ) {
      if (
        parseInt(activityByIdDetails?.data?.status) === 2 &&
        isCheckoutDetails?.data?.check_out_lat === null
      ) {
        setOpenCheckIn(true);
        setCheckInText("Check out");
      } else if (
        parseInt(activityByIdDetails?.data?.status) === 1 &&
        isCheckoutDetails?.data?.check_out_lat === null
      ) {
        setOpenCheckIn(false);
      }
      setTimeout(() => {
        setIsLoading(true);
        setIsLoading(false);
      }, 1000);
    }
  }, [activityByIdDetails, isCheckoutDetails]);

  // useEffect(() => {
  //     if (accountByIdDetails?.data !== undefined && accountByIdDetails?.data?.longitude !== undefined &&
  //         islatlng?.lat !== undefined && islatlng?.lat !== null) {
  //         let distance = calcCrow(accountByIdDetails?.data?.latitude, accountByIdDetails?.data?.longitude, islatlng?.lat, islatlng?.lng)
  //         setDistance(parseFloat(distance).toFixed(2))
  //         setTimeout(() => {
  //             setIsLoading(true)
  //             setIsLoading(false)
  //         }, 1000)
  //     }
  // }, [accountByIdDetails, islatlng?.lat])
  //
  // useEffect(() => {
  //     if (parseInt(distance) > 500) {
  //         toast.warning("Your are outside 500 meter radius of the site")
  //     }
  // }, [distance])

  useEffect(() => {
    setIsFailedModalOpen(false);
    setIsSuccessModalOpen(false);
    // show check out after complete activity
    if (
      saveActivityRes?.data !== undefined &&
      saveActivityRes?.status === 200
    ) {
      // setMessage(saveActivityRes?.message)
      // setIsSuccessModalOpen(true)
      setOpenCheckIn(true);
      setCheckInText("Check out");
    } else if (
      saveActivityRes?.data !== undefined &&
      saveActivityRes?.status !== 200
    ) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
      setMessage(saveActivityRes?.message);
    }
  }, [saveActivityRes]);

  return (
    <>
      {/*<SuccessModal*/}
      {/*    isOpen={isSuccessModalOpen}*/}
      {/*    msg={message}*/}
      {/*    url={`ba-activity-list/${match?.params?.lead_id}`}*/}
      {/*/>*/}

      <FailedModal
        isOpen={isFailedModalOpen}
        msg={message}
        countToOpenModal={countToOpenModal}
      />
      <Loader isLoading={isLoading} />

      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Activity"} history={history} />
            {/*BODY*/}

            <div className="container-fluid common-bg">
              {openCheckIn ? (
                <div className="popup-box">
                  <div className="box">
                    <DistanceCalculator
                      isMapShow={true}
                      calculateDistance={markAttendance}
                      moduleType={"BA"}
                      checkInText={checkInText}
                      checkoutId={
                        isCheckoutDetails?.data !== undefined
                          ? isCheckoutDetails?.data?.id
                          : 0
                      }
                      activityId={
                        activityByIdDetails?.data?.id !== undefined
                          ? activityByIdDetails?.data?.id
                          : ""
                      }
                      accountId={
                        activityByIdDetails?.data?.account_id !== undefined
                          ? activityByIdDetails?.data?.account_id
                          : ""
                      }
                      documentUploadUrlPublic={documentUploadUrlPublic}
                      documentUrlDataPublic={documentUrlDataPublic}
                      attendanceResponse={attendance}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                          <h1 className="h3 mb-0 text-black-100">
                            {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                            {/*<span style={{color: "green"}}> {distance}</span>*/}
                          </h1>
                        </div>
                        {/*<div className="mb-0 bg-white">*/}
                        <>
                          <div className="card-body bg-white">
                            <div className="user">
                              <div className="form-group row">
                                <div className="col-sm-6 mt-1 float-field">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "activity_type_id",
                                        e.target.value,
                                        e
                                      );
                                    }}
                                    disabled={true}
                                  >
                                    <option value="">Select Activity</option>
                                    {activityTypesDetails?.data !== undefined &&
                                      activityTypesDetails?.data.map((val) => {
                                        return (
                                          <>
                                            {activityByIdDetails?.data
                                              ?.activity_type_id !==
                                              undefined &&
                                            activityByIdDetails?.data
                                              ?.activity_type_id ===
                                              parseInt(val?.id) ? (
                                              <option
                                                value={val?.id}
                                                selected={true}
                                              >
                                                {val.name}
                                              </option>
                                            ) : (
                                              <option value={val?.id}>
                                                {val.name}
                                              </option>
                                            )}
                                          </>
                                        );
                                      })}
                                  </select>
                                  <label className="large-label float-lb">
                                    Activity Type
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-075 float-field">
                                  <input
                                    type="datetime-local"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      handleInput(
                                        "activity_date",
                                        e.target.value,
                                        e
                                      );
                                    }}
                                    id="validationCustom01"
                                    disabled={true}
                                    // value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date :""}
                                    max={
                                      new Date().toISOString().split("T")[0] +
                                      "T00:00"
                                    }
                                    value={currentDate}
                                  />
                                  <label className="large-label float-lb">
                                    Activity Date
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-075 float-field mb-4">
                                  <textarea
                                    className="form-control form-control-user cus-red"
                                    placeholder="Remark*"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "remark",
                                        e
                                      );
                                    }}
                                    required
                                    rows="4"
                                    cols="50"
                                  />
                                  <label className="large-label float-lb">
                                    {/*Remark*/}
                                  </label>
                                </div>
                                {/* <div
                className="col-sm-6 mt-1 float-field">
                <select
                    className="form-control form-control-user"
                    onChange={(e) => {
                        // handlePrimaryLeadStatus(i, e.target.value, 'lead_status')
                    }} 
                    required
                >
                    <option value="FASTag replacement camp">FASTag replacement camp
                    </option>
                    <option value="Car display camp">Car display camp
                    </option>
                    <option value="Brand placement kiosking">Brand placement kiosking
                    </option>
                    <option value="Sampling activity">Sampling activity
                    </option>
                    <option value="Door to door campaign">Door to door campaign
                    </option>
                </select>
                <label
                    className="large-label float-lb">
                    Brand carnivals 
                    <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div> */}
                              </div>

                              {/*<div className="col-sm-6 mtk-075 float-field mb-4">*/}
                              {/*<textarea*/}
                              {/*    className="form-control form-control-user"*/}
                              {/*    placeholder=" Description"*/}
                              {/*    onChange={(e) => {*/}
                              {/*        handleInput('meta_data', e.target.value, 'Remark', e)*/}
                              {/*    }}*/}
                              {/*    id="validationCustom01"*/}
                              {/*    rows="4" cols="50"*/}
                              {/*    required={true}*/}
                              {/*/>*/}
                              {/*    <label className="large-label float-lb">*/}
                              {/*        /!*Description*!/*/}
                              {/*    </label>*/}
                              {/*</div>*/}
                            </div>
                          </div>
                          {activityByIdDetails?.data?.reason !== undefined &&
                            activityByIdDetails?.data?.reason !== null &&
                            activityByIdDetails?.data?.reason !== [] &&
                            Object.keys(activityByIdDetails?.data?.reason)
                              .length > 0 &&
                            activityByIdDetails?.data?.reason[0] !==
                              undefined &&
                            activityByIdDetails?.data?.reason[0]
                              ?.primary_product !== undefined &&
                            activityByIdDetails?.data?.reason[0]
                              ?.primary_product[0] !== undefined &&
                            Object.keys(
                              activityByIdDetails?.data?.reason[0]
                                ?.primary_product[0]
                            ).length > 0 && (
                              <>
                                <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                  <h1 className="h3 mb-0 text-black-100">
                                    <b>Primary Product</b>
                                  </h1>
                                </div>
                                <div className="card-body bg-white">
                                  <div className="user">
                                    <div className="form-group row">
                                      {activityByIdDetails?.data?.reason[0]?.primary_product.map(
                                        (val, i) => {
                                          return (
                                            <>
                                              <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading"
                                                style={{ width: "100%" }}
                                              >
                                                <h1 className="h3 mb-0 text-black-100">
                                                  <b>{val?.reason}</b>
                                                </h1>
                                              </div>
                                              <div className="col-sm-6 mt-1 float-field">
                                                <select
                                                  className="form-control form-control-user"
                                                  onChange={(e) => {
                                                    handlePrimaryLeadStatus(
                                                      i,
                                                      e.target.value,
                                                      "lead_status"
                                                    );
                                                  }}
                                                  required
                                                >
                                                  <option value="">
                                                    Select Lead status
                                                  </option>
                                                  <option value="Hot">
                                                    Hot
                                                  </option>
                                                  <option value="Cold">
                                                    Cold
                                                  </option>
                                                  <option value="Warm">
                                                    Warm
                                                  </option>
                                                  <option value="Closed - Won">
                                                    Closed - Won
                                                  </option>
                                                  <option value="Closed - Dropped">
                                                    Closed - Dropped
                                                  </option>
                                                </select>
                                                <label className="large-label float-lb">
                                                  Lead status{" "}
                                                  <i className="bi bi-asterisk astrick-icon"></i>
                                                </label>
                                              </div>
                                              <div className="col-sm-6 mtk-075 float-field">
                                                <input
                                                  type="number"
                                                  className="form-control form-control-user"
                                                  placeholder=" "
                                                  onChange={(e) => {
                                                    handlePrimaryLeadStatus(
                                                      i,
                                                      e.target.value,
                                                      "price"
                                                    );
                                                  }}
                                                  id="validationCustom01"
                                                  // value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date :""}
                                                  // max={new Date().toISOString().split("T")[0] + "T00:00"}
                                                />
                                                <label className="large-label float-lb">
                                                  Price quoted
                                                </label>
                                              </div>
                                              {(primaryLeadStatus[0][
                                                "lead_status"
                                              ][i] === "Hot" ||
                                                primaryLeadStatus[0][
                                                  "lead_status"
                                                ][i] === "Cold" ||
                                                primaryLeadStatus[0][
                                                  "lead_status"
                                                ][i] === "Warm") && (
                                                <>
                                                  <div className="col-sm-6 mtk-075 float-field">
                                                    <input
                                                      type="date"
                                                      className="form-control form-control-user"
                                                      placeholder=" "
                                                      onChange={(e) => {
                                                        handlePrimaryLeadStatus(
                                                          i,
                                                          e.target.value,
                                                          "follow_up_date"
                                                        );
                                                      }}
                                                      id="validationCustom01"
                                                      // value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date :""}
                                                      // max={new Date().toISOString().split("T")[0] + "T00:00"}
                                                    />
                                                    <label className="large-label float-lb">
                                                      Follow-up date
                                                    </label>
                                                  </div>
                                                </>
                                              )}
                                              {primaryLeadStatus[0][
                                                "lead_status"
                                              ][i] === "Closed - Won" && (
                                                <>
                                                  <div className="col-sm-6 mt-1 float-field">
                                                    <select
                                                      className="form-control form-control-user"
                                                      onChange={(e) => {
                                                        handlePrimaryLeadStatus(
                                                          i,
                                                          e.target.value,
                                                          "signed"
                                                        );
                                                      }}
                                                      required
                                                    >
                                                      <option value="">
                                                        Select Has the PO /
                                                        Contract been signed
                                                      </option>
                                                      <option value="Yes">
                                                        Yes
                                                      </option>
                                                      <option value="No">
                                                        No
                                                      </option>
                                                    </select>
                                                    <label className="large-label float-lb">
                                                      Has the PO / Contract been
                                                      signed{" "}
                                                      <i className="bi bi-asterisk astrick-icon"></i>
                                                    </label>
                                                  </div>
                                                </>
                                              )}
                                              {primaryLeadStatus[0]["signed"][
                                                i
                                              ] === "Yes" && (
                                                <>
                                                  <div className="col-sm-6 mt-1 float-field">
                                                    <select
                                                      className="form-control form-control-user"
                                                      onChange={(e) => {
                                                        handlePrimaryLeadStatus(
                                                          i,
                                                          e.target.value,
                                                          "cheque"
                                                        );
                                                      }}
                                                      required
                                                    >
                                                      <option value="">
                                                        Select Has the
                                                        cheque/NEFT been
                                                        received
                                                      </option>
                                                      <option value="Yes">
                                                        Yes
                                                      </option>
                                                      <option value="No">
                                                        No
                                                      </option>
                                                    </select>
                                                    <label className="large-label float-lb">
                                                      Has the cheque/NEFT been
                                                      received{" "}
                                                      <i className="bi bi-asterisk astrick-icon"></i>
                                                    </label>
                                                  </div>
                                                </>
                                              )}
                                              {primaryLeadStatus[0][
                                                "lead_status"
                                              ][i] === "Closed - Dropped" && (
                                                <>
                                                  <div className="col-sm-6 mtk-075 float-field">
                                                    <input
                                                      type="text"
                                                      className="form-control form-control-user"
                                                      placeholder=" "
                                                      onChange={(e) => {
                                                        handlePrimaryLeadStatus(
                                                          i,
                                                          e.target.value,
                                                          "Dropped"
                                                        );
                                                      }}
                                                      id="validationCustom01"
                                                      // value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date :""}
                                                      max={
                                                        new Date()
                                                          .toISOString()
                                                          .split("T")[0] +
                                                        "T00:00"
                                                      }
                                                    />
                                                    <label className="large-label float-lb">
                                                      Reason for dropout
                                                    </label>
                                                  </div>
                                                </>
                                              )}
                                            </>
                                          );
                                        }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}

                          {activityByIdDetails?.data?.reason !== undefined &&
                            activityByIdDetails?.data?.reason !== null &&
                            activityByIdDetails?.data?.reason !== [] &&
                            Object.keys(activityByIdDetails?.data?.reason)
                              .length > 0 &&
                            activityByIdDetails?.data?.reason[0] !==
                              undefined &&
                            activityByIdDetails?.data?.reason[0]
                              ?.add_on_product !== undefined &&
                            activityByIdDetails?.data?.reason[0]
                              ?.add_on_product[0] !== undefined &&
                            Object.keys(
                              activityByIdDetails?.data?.reason[0]
                                ?.add_on_product[0]
                            ).length > 0 && (
                              <>
                                <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                  <h1 className="h3 mb-0 text-black-100">
                                    <b>Add On Product</b>
                                  </h1>
                                </div>
                                <div className="card-body bg-white">
                                  <div className="user">
                                    <div className="form-group row">
                                      {activityByIdDetails?.data?.reason[0]?.add_on_product.map(
                                        (val, i) => {
                                          return (
                                            <>
                                              {val?.reason !== "" &&
                                                val?.reason !== undefined && (
                                                  <>
                                                    <div
                                                      className="d-sm-flex align-items-center justify-content-between com-sub-heading"
                                                      style={{ width: "100%" }}
                                                    >
                                                      <h1 className="h3 mb-0 text-black-100">
                                                        <b>{val?.reason}</b>
                                                      </h1>
                                                    </div>
                                                    <div className="col-sm-6 mt-1 float-field">
                                                      <select
                                                        className="form-control form-control-user"
                                                        onChange={(e) => {
                                                          handleAddOnLeadStatus(
                                                            i,
                                                            e.target.value,
                                                            "lead_status"
                                                          );
                                                        }}
                                                        required
                                                      >
                                                        <option value="">
                                                          Select Lead status
                                                        </option>
                                                        <option value="Hot">
                                                          Hot
                                                        </option>
                                                        <option value="Cold">
                                                          Cold
                                                        </option>
                                                        <option value="Warm">
                                                          Warm
                                                        </option>
                                                        <option value="Closed - Won">
                                                          Closed - Won
                                                        </option>
                                                        <option value="Closed - Dropped">
                                                          Closed - Dropped
                                                        </option>
                                                      </select>
                                                      <label className="large-label float-lb">
                                                        status{" "}
                                                        <i className="bi bi-asterisk astrick-icon"></i>
                                                      </label>
                                                    </div>
                                                    <div className="col-sm-6 mtk-075 float-field">
                                                      <input
                                                        type="number"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          handleAddOnLeadStatus(
                                                            i,
                                                            e.target.value,
                                                            "price"
                                                          );
                                                        }}
                                                        id="validationCustom01"
                                                        // value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date :""}
                                                        // max={new Date().toISOString().split("T")[0] + "T00:00"}
                                                      />
                                                      <label className="large-label float-lb">
                                                        Price quoted
                                                      </label>
                                                    </div>
                                                    {(addOnLeadStatus[0][
                                                      "lead_status"
                                                    ][i] === "Hot" ||
                                                      addOnLeadStatus[0][
                                                        "lead_status"
                                                      ][i] === "Cold" ||
                                                      addOnLeadStatus[0][
                                                        "lead_status"
                                                      ][i] === "Warm") && (
                                                      <>
                                                        <div className="col-sm-6 mtk-075 float-field">
                                                          <input
                                                            type="date"
                                                            className="form-control form-control-user"
                                                            placeholder=" "
                                                            onChange={(e) => {
                                                              handleAddOnLeadStatus(
                                                                i,
                                                                e.target.value,
                                                                "follow_up_date"
                                                              );
                                                            }}
                                                            id="validationCustom01"
                                                            // value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date :""}
                                                            // max={new Date().toISOString().split("T")[0] + "T00:00"}
                                                          />
                                                          <label className="large-label float-lb">
                                                            Follow-up date
                                                          </label>
                                                        </div>
                                                      </>
                                                    )}
                                                    {addOnLeadStatus[0][
                                                      "lead_status"
                                                    ][i] === "Closed - Won" && (
                                                      <>
                                                        <div className="col-sm-6 mt-1 float-field">
                                                          <select
                                                            className="form-control form-control-user"
                                                            onChange={(e) => {
                                                              handleAddOnLeadStatus(
                                                                i,
                                                                e.target.value,
                                                                "signed"
                                                              );
                                                            }}
                                                            required
                                                          >
                                                            <option value="">
                                                              Select Has the
                                                              PO/Contract been
                                                              signed
                                                            </option>
                                                            <option value="Yes">
                                                              Yes
                                                            </option>
                                                            <option value="No">
                                                              No
                                                            </option>
                                                          </select>
                                                          <label className="large-label float-lb">
                                                            Has the PO/Contract
                                                            been signed{" "}
                                                            <i className="bi bi-asterisk astrick-icon"></i>
                                                          </label>
                                                        </div>
                                                      </>
                                                    )}
                                                    {addOnLeadStatus[0][
                                                      "signed"
                                                    ][i] === "Yes" && (
                                                      <>
                                                        <div className="col-sm-6 mt-1 float-field">
                                                          <select
                                                            className="form-control form-control-user"
                                                            onChange={(e) => {
                                                              handleAddOnLeadStatus(
                                                                i,
                                                                e.target.value,
                                                                "cheque"
                                                              );
                                                            }}
                                                            required
                                                          >
                                                            <option value="">
                                                              Select Has the
                                                              cheque/NEFT been
                                                              received
                                                            </option>
                                                            <option value="Yes">
                                                              Yes
                                                            </option>
                                                            <option value="No">
                                                              No
                                                            </option>
                                                          </select>
                                                          <label className="large-label float-lb">
                                                            Has the cheque/NEFT
                                                            been received{" "}
                                                            <i className="bi bi-asterisk astrick-icon"></i>
                                                          </label>
                                                        </div>
                                                      </>
                                                    )}
                                                    {addOnLeadStatus[0][
                                                      "lead_status"
                                                    ][i] ===
                                                      "Closed - Dropped" && (
                                                      <>
                                                        <div className="col-sm-6 mtk-075 float-field">
                                                          <input
                                                            type="text"
                                                            className="form-control form-control-user"
                                                            placeholder=" "
                                                            onChange={(e) => {
                                                              handleAddOnLeadStatus(
                                                                i,
                                                                e.target.value,
                                                                "Dropped"
                                                              );
                                                            }}
                                                            id="validationCustom01"
                                                            // value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date :""}
                                                            max={
                                                              new Date()
                                                                .toISOString()
                                                                .split("T")[0] +
                                                              "T00:00"
                                                            }
                                                          />
                                                          <label className="large-label float-lb">
                                                            Reason for dropout
                                                          </label>
                                                        </div>
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                            </>
                                          );
                                        }
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                        </>
                        {/*</div>*/}
                        <div className="col-md-12 mt-4 d-flex">
                          <button className="btn btn-primary btn-user btn-block submit-btn">
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompleteBaActivity;
